import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** Created by Andrey Gayvoronsky on 13/04/16. */
import CalendarLocale from '../../vc-picker/locale/ru_RU';
import TimePickerLocale from '../../time-picker/locale/ru_RU'; // Merge into a locale object

var locale = {
  lang: _objectSpread({
    placeholder: 'Выберите дату',
    yearPlaceholder: 'Выберите год',
    quarterPlaceholder: 'Выберите квартал',
    monthPlaceholder: 'Выберите месяц',
    weekPlaceholder: 'Выберите неделю',
    rangePlaceholder: ['Начальная дата', 'Конечная дата'],
    rangeYearPlaceholder: ['Начальный год', 'Год окончания'],
    rangeMonthPlaceholder: ['Начальный месяц', 'Конечный месяц'],
    rangeWeekPlaceholder: ['Начальная неделя', 'Конечная неделя']
  }, CalendarLocale),
  timePickerLocale: _objectSpread({}, TimePickerLocale)
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;